var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscipline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 1.40625H4.59375V2.65234C4.27148 2.52344 3.92773 2.4375 3.5625 2.4375V1.40625V0.375H4.59375H12.8438H13.875V1.40625V8.28125V9.3125H12.8438H11.8125H11.2969H8.54688H8.03125H7.08594L6.78516 8.28125H8.03125V6.73438V6.21875H8.54688H11.2969H11.8125V6.73438V8.28125H12.8438V1.40625ZM10.7812 8.28125V7.25H9.0625V8.28125H10.7812ZM4.59375 5.1875C4.59375 4.82227 4.37891 4.5 4.07812 4.30664C3.75586 4.11328 3.34766 4.11328 3.04688 4.30664C2.72461 4.5 2.53125 4.82227 2.53125 5.1875C2.53125 5.57422 2.72461 5.89648 3.04688 6.08984C3.34766 6.2832 3.75586 6.2832 4.07812 6.08984C4.37891 5.89648 4.59375 5.57422 4.59375 5.1875ZM1.5 5.1875C1.5 4.45703 1.88672 3.79102 2.53125 3.4043C3.1543 3.03906 3.94922 3.03906 4.59375 3.4043C5.2168 3.79102 5.625 4.45703 5.625 5.1875C5.625 5.93945 5.2168 6.60547 4.59375 6.99219C3.94922 7.35742 3.1543 7.35742 2.53125 6.99219C1.88672 6.60547 1.5 5.93945 1.5 5.1875ZM1.5 10.3438H5.60352L5.19531 8.96875H1.9082L1.5 10.3438ZM1.15625 7.9375H5.96875L6.67773 10.3438L7 11.375H5.9043H1.19922H0.125L0.425781 10.3438L1.15625 7.9375Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscipline);
export default __webpack_public_path__ + "static/media/discipline.a8a1a912441b69b4378a755650068fd7.svg";
export { ForwardRef as ReactComponent };